import { Helmet } from "react-helmet";

import {
  Box,
  Container,
  Grid,
  Typography,
  Paper,
  Select, MenuItem, TextField,
  Button,
  FormLabel,
  Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel,
  Toolbar, ListSubheader,
  Checkbox, FormControlLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';

import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrow-rightFFF.svg";

import * as Util from "../../../../services/global.service";
import ReportService from "../../../../services/report.service"

const COLOR_BUTTON = '#5DA196'

const useStyles = makeStyles({
  customAvatarColor: {
    color: "red",
  },
  cardContentHeaderSize: {
    display: "flex",
  },
  cardContentSize: {
    display: "flex",
    justifyContent: "center",
    // flexFlow: "row",
    alignItems: "center",
    height: "calc(100% - 130px)",
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap"
  },
  customCardSize: {
    height: 380,
  },
  titleColor: {
    color: "#B5B5B5"
  },
  subTitleColor: {
    color: "#404349",
    paddingTop: "10px",
    wordBreak: "break-all"
  },
  plusSvg: {
    "& > path": {
      fill: "#fff",
      stroke: "#fff",
    },
  },
  flexPaper: {
    flex: 1,
    minWidth: 350,
    padding: 12,
    // "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        "
  },
  flexPaperReport: {
    flex: 1,
    minWidth: 350,
    padding: 12,
    marginTop: 10, marginBottom: 10,
    // "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        "
  },
  root: {
    display: 'flex',
    width: "100%",
    flexWrap: 'wrap'
  }
});
const styles = {
  containerProfile: {
    padding: "22px 25px 40px 24px",
  },
  containerCardContent: {
    paddingTop: "38px"
  },
  buttonPMS: {
    backgroundColor: COLOR_BUTTON,
    borderColor: COLOR_BUTTON,
    color: '#FFFFFF'
  }
}

const ReportDetail = () => {

  const current_language = localStorage.getItem("lang")

  const { t } = useTranslation();
  const { serial } = useParams();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [report, setReport] = useState();
  const [filters, setFilters] = useState([]);
  const [allow_adjust, setAllow_adjust] = useState(true);
  const [filterValue, setFilterValue] = useState({ language: current_language.split('-').shift() });
  const [isFilter, setIsFilter] = useState(false)
  const [logID, setLogID] = useState('')
  const [isChanged, setIsChanged] = useState(true)
  const [hidden, sethidden] = useState(false)

  const [headers, setHeaders] = useState([])
  const [rows, setRows] = useState([])
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const onScroll = (evt) => {
    if (evt !== undefined && evt !== null) {
      if (open) {
        setOpen(false)
      }
    }
  }


  useEffect(() => {
    console.log('Report', serial)
    setFilters([])
    setFilterValue({ language: current_language.split('-').shift() })
    setIsFilter(false)
    setLogID('')
    setIsChanged(true)
    setHeaders([])
    setSelected([])
    setRows([])
    setPage(0)
    setDense(false)
    setRowsPerPage(10)
    setReport()

    async function fetchData() {
      try {

        const rs = await ReportService.getReport(serial)
        const report_data = Util.formatData(rs?.data, {})
        setReport(report_data.report)
        setFilters(report_data.filter)
        //console.log(report_data)


      } catch (error) {
        console.error(error)
      }
    }

    fetchData();

  }, [serial])

  const queryData = async (opt = {}) => {
    let data = Object.assign({}, filterValue)
    if (Object.keys(opt).length > 0) {
      data = Object.assign(data, opt)
      data["logid"] = logID
    }
    else {
      if (isChanged) setLogID('')
    }

    //console.log('filterValue', filterValue)

    setIsFilter(true)

    try {

      if (!data['export']) {
        setRows([])
        setPage(0)
        setDense(false)
      }

      const rs = await ReportService.queryReportData(report.id, data)
      const report_data = Util.formatData(rs?.data, {})

      if (report_data.file) {

        window.location.href = report_data.file

      }
      else {

        setHeaders(report_data.fields)
        setRows(report_data.rows)
        setLogID(report_data.logid)
      }

      setIsChanged(false)

    } catch (error) {

    }

  }

  const changeValue = (field, e) => {
    const value = e.target.value || '';

    const changed = (!filterValue[field] || (filterValue[field] && filterValue[field] !== value))
    setIsChanged(changed)

    filterValue[field] = value

    setFilterValue(filterValue)
    //console.log('changeValue', field, value, filterValue)

    setFilters([...filters])
  }


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }


  const EnhancedTableToolbar = (props) => {
    const total = rows.length

    return (
      <Toolbar
        sx={{
          pl: "0 !important",
          pr: { xs: 1, sm: 1 },
          minHeight: "unset !important",
          marginTop: "12px",

        }}
      >
        {hidden ?
          <Box pr="15px">
            <Box onClick={e => sethidden(false)} sx={{ background: "#5DA196", width: "35px", height: "35px", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
              <ArrowRight />
            </Box>
          </Box>
          :
          null
        }
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h2"
          component="div"
          fontSize={24} lineHeight="35px"
          color={'#404349'}
        >
          {t("label.preview_Report")}
          {isFilter &&
            <span>({total})</span>
          }
        </Typography>

        {total > 0 &&
          <>
            <Button variant="contained" size="small" color="success" style={styles.buttonPMS} onClick={() => { queryData({ export: 'y' }) }}>Export</Button>
          </>
        }
      </Toolbar>
    );
  };

  const EnhancedTableHead = (props) => {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow style={{ backgroundColor: '#5DA196', color: '#FFFFFF' }}>
          {headers.map((headCell) => (
            <TableCell
              key={headCell.field}
              align={'center'}
              padding={'normal'}
              sortDirection={orderBy === headCell.field ? order : false}
              sx={{ backgroundColor: '#5DA196', minWidth: 150 }}
            >
              <TableSortLabel
                active={orderBy === headCell.field}
                direction={orderBy === headCell.field ? order : 'asc'}
                onClick={createSortHandler(headCell.field)}
                style={{ color: '#FFFFFF' }}
              >
                {headCell.label}
                {orderBy === headCell.field ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const getDropdownGroup = (opt) => {
    let options = [];

    options.push(<ListSubheader>{opt.name}</ListSubheader>);

    (opt.data || []).map((opt, i) => {
      options.push(<MenuItem value={opt.id}>{opt.name}</MenuItem>)
    })

    return options
  }

  const isAllRequired = () => {
    let isAll = true;

    filters.map(f => {
      if (f.required) {

        if (!filterValue[f.code]) isAll = false;

      }
    })


    return isAll
  }


  const goBack = () => {
    let path = '/admin/report'
    navigate(path, { replace: false });
  }


  return (

    <Box onScroll={onScroll} style={{ "max-height": "100%", "overflow-y": "auto" }}>
      <Helmet>
        <title>HOME | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth="xl">
          {report &&
            <>
              <Grid container item >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px">
                  <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                    {report.name}
                  </Typography>
                </Box>
              </Grid>

              <Box mt={3} sx={{ display: "flex", width: "100%" }}>
                <Box sx={{ width: hidden ? "0px" : "374px", overflow: "hidden", transition: "all .8s" }}>
                  <Paper className={classes.flexPaper} sx={{ width: 350 }}>
                    <Grid container >
                      <Grid item xs={12}>
                        <Box display="flex">
                          <Typography variant="h2" color="#5DA196" fontSize={24} lineHeight="35px" width="calc(100% - 55px)">
                            {t("label.filterReport")}
                          </Typography>
                          <Box pl="15px">
                            <Box onClick={e => sethidden(true)} sx={{ width: "35px", height: "35px", border: "1px solid #5DA196", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                              <ArrowLeft />
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      {/* <Grid item xs={1} style={{ display: 'none' }}>
                        <IconButton color="success" size="small" onClick={() => { goBack() }}><ArrowBackIosOutlinedIcon fontSize="small" style={{ color: COLOR_BUTTON }} /></IconButton>
                      </Grid> */}
                    </Grid>

                    {filters.map((filter, i) => (

                      <Box key={i} sx={{ width: "100%", position: "relative", marginTop: 1, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >

                        {filter.type !== 'checkbox' &&
                          <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={16} lineHeight="26.91px" display="flex">
                            {filter.label}
                            {filter.required && <span style={{ color: '#CC6058' }}>*</span>}
                          </Typography>
                        }

                        {filter.type === 'search' &&
                          <TextField
                            name={filter.code}
                            onChange={(e) => changeValue(filter.code, e)}
                            fullWidth type="text" variant="outlined" InputLabelProps={{ shrink: true, }}
                            sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                            placeholder=""
                            size="small"
                          />
                        }

                        {filter.type === 'dropdown' &&

                          <Select
                            name={filter.code}
                            fullWidth margin="normal" variant="outlined" InputLabelProps={{ shrink: true, }}
                            size="small"
                            onChange={(e) => changeValue(filter.code, e)}
                            disabled={(filter.depend && !filterValue[filter.depend])}
                            required={(filter.required)}
                          >
                            {!filter.required && <MenuItem value=""><em>{t('admin.label.report.selectAll')}</em></MenuItem>}
                            {(filter.data || []).map((opt, i) => {


                              if (!filter.depend || (filter.depend && filterValue[filter.depend] && opt[filter.depend] === filterValue[filter.depend])) {
                                return (
                                  <MenuItem key={i} value={opt.id}>{opt.name}</MenuItem>
                                )
                              }
                            })}
                          </Select>
                        }

                        {filter.type === 'dropdowngroup' &&

                          <Select
                            name={filter.code}
                            fullWidth margin="normal" variant="outlined" InputLabelProps={{ shrink: true, }}
                            size="small"
                            onChange={(e) => changeValue(filter.code, e)}
                            disabled={(filter.depend && !filterValue[filter.depend])}
                          >
                            {!filter.required && <MenuItem value=""><em>{t('admin.label.report.selectAll')}</em></MenuItem>}
                            {(filter.data || []).map((opt, i) => {

                              if (!filter.depend || (filter.depend && filterValue[filter.depend] && opt[filter.depend] === filterValue[filter.depend])) {

                                return getDropdownGroup(opt)

                              }
                            })}
                          </Select>
                        }

                        {filter.type === 'date' &&
                          <TextField
                            name={filter.code}
                            onChange={(e) => changeValue(filter.code, e)}
                            fullWidth type="date" variant="outlined" InputLabelProps={{ shrink: true, }}
                            sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                            placeholder=""
                            size="small"
                          />
                        }

                        {filter.type === 'period' &&

                          <Grid container spacing={0}>
                            <Grid item xs={5}>
                              <TextField
                                name={filter.code + '_startdate'}
                                onChange={(e) => changeValue(filter.code + '_startdate', e)}
                                fullWidth type="date" variant="outlined" InputLabelProps={{ shrink: true, }}
                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                placeholder=""
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={2} style={{ textAlign: 'center', display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <FormLabel >-</FormLabel>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                name={filter.code + '_enddate'}
                                onChange={(e) => changeValue(filter.code + '_enddate', e)}
                                fullWidth type="date" variant="outlined" InputLabelProps={{ shrink: true, }}
                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                placeholder=""
                                size="small"
                              />
                            </Grid>
                          </Grid>
                        }

                        {filter.type === 'min-max' &&

                          <Grid container spacing={0}>
                            <Grid item xs={5}>
                              <TextField
                                name={filter.code + '_min'}
                                onChange={(e) => changeValue(filter.code + '_min', e)}
                                fullWidth type="number" variant="outlined" InputLabelProps={{ shrink: true, }}
                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                placeholder=""
                                classes={{ root: serial !== undefined ? classes.disabled : allow_adjust === true ? classes.input : classes.disabled }}
                                size="small"
                                inputProps={{ step: ".1", min: 0 }}
                              />
                            </Grid>
                            <Grid item xs={2} style={{ textAlign: 'center', display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <FormLabel >-</FormLabel>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                name={filter.code + '_max'}
                                onChange={(e) => changeValue(filter.code + '_max', e)}
                                fullWidth type="number" variant="outlined" InputLabelProps={{ shrink: true, }}
                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                placeholder=""
                                size="small"
                                inputProps={{ step: ".1", min: 0 }}
                              />
                            </Grid>
                          </Grid>
                        }

                        {filter.type === 'checkbox' &&

                          <FormControlLabel
                            control={<Checkbox
                              name={filter.code}
                              onChange={(e) => changeValue(filter.code, { target: { value: e.target.checked ? 'y' : 'n' } })}
                              sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                            />}
                            label={<Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={16} lineHeight="26.91px" display="flex">{filter.label}</Typography>}
                            required={filter.required}
                          />


                        }

                      </Box>

                    ))}

                    <Box sx={{ width: "100%", position: "relative", marginTop: 1, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >
                      <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={16} lineHeight="26.91px" display="flex">Language</Typography>



                      <Select
                        name={'language'}
                        fullWidth margin="normal" variant="outlined" InputLabelProps={{ shrink: true, }}
                        size="small"
                        defaultValue={filterValue['language']}
                        onChange={(e) => changeValue('language', e)}
                      >
                        <MenuItem value={'th'}>{'TH'}</MenuItem>
                        <MenuItem value={'en'}>{'EN'}</MenuItem>
                      </Select>
                    </Box>

                    <Box sx={{ width: "100%", position: "relative", marginTop: 2, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >
                      <Button variant="contained" style={{ backgroundColor: !isAllRequired() ? "#BABABA" : COLOR_BUTTON, borderColor: COLOR_BUTTON, color: '#FFFFFF' }} fullWidth onClick={() => { queryData() }} disabled={!isAllRequired()}>
                        {t('label.previewReport')}
                      </Button>
                    </Box>

                  </Paper>
                </Box>
                <Box sx={{ width: hidden ? "100%" : "calc(100% - 374px)", transition: "all .8s" }} >
                  <EnhancedTableToolbar />
                  {isFilter > 0 &&
                    <Paper className={classes.flexPaper} style={{ marginTop: 2 }}>

                      <TableContainer sx={{ maxHeight: 800 }}>
                        <Table
                          sx={{ minWidth: 750 }}
                          aria-labelledby="tableTitle"
                          stickyHeader
                          // aria-label="sticky table"
                          size={dense ? 'small' : 'medium'}
                        >
                          <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                          />
                          <TableBody>
                            {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                            {stableSort(rows, getComparator(order, orderBy))
                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              .map((row, index) => {
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                  <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.name}
                                  >
                                    {row.map((cell, i) => {
                                      if (i === 0) {
                                        return (
                                          <TableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                            align="center"
                                          >
                                            {cell}
                                          </TableCell>
                                        )
                                      } else {
                                        return (
                                          <TableCell align="center">{cell}</TableCell>
                                        )
                                      }
                                    })}
                                  </TableRow>
                                );
                              })}
                            {emptyRows > 0 && (
                              <TableRow
                                style={{
                                  height: (dense ? 33 : 53) * emptyRows,
                                }}
                              >
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />


                    </Paper>
                  }

                </Box>
              </Box>

            </>
          }

        </Container>
      </Box>
    </Box >
  )
}


export default ReportDetail;
